import { gsap } from "gsap";

export default class HeaderMenu {
    constructor({
        trigger = ".js-hamburger",
        overlay = ".js-menuOverlay",
        panel = ".js-menuOverlayPanel",
        head = ".js-menuHead",
        items = ".js-menuItems li",
        openClass = "is-open",
        lockClass = "is-menuOpen",
    } = {}) {
        this.$trigger = document.querySelector(trigger);
        this.$overlay = document.querySelector(overlay);
        this.$panel = document.querySelector(panel);
        this.$head = this.$panel ? this.$panel.querySelector(head) : null;
        this.$items = Array.from(document.querySelectorAll(items));

        if (!this.$trigger || !this.$overlay || !this.$panel) return;

        this.openClass = openClass;
        this.lockClass = lockClass;
        this.isOpen = false;

        // 初期状態
        gsap.set(this.$overlay, { autoAlpha: 0 });
        gsap.set(this.$panel, { clipPath: "inset(0% 0% 0% 100%)" });
        gsap.set(this.$head, { x: 100, autoAlpha: 0 });
        gsap.set(this.$items, { x: 50, autoAlpha: 0 });

        this.tl = gsap.timeline({
            paused: true,
            defaults: { ease: "power2.inOut" },
            onStart: () => {
                this.$overlay.style.pointerEvents = "auto";
                this.$overlay.setAttribute("aria-hidden", "false");
            },
            onReverseComplete: () => {
                this.$overlay.style.pointerEvents = "none";
                this.$overlay.setAttribute("aria-hidden", "true");
            },
        });

        this.tl
            .to(this.$overlay, { autoAlpha: 1, duration: 0.18 }, 0)
            .to(this.$panel, { clipPath: "inset(0% 0% 0% 0%)", duration: 0.55 }, 0)
            .to(this.$head, { x: 0, autoAlpha: 1, duration: 0.28 }, 0.1)
            .to(this.$items, { x: 0, autoAlpha: 1, duration: 0.35, stagger: 0.04 }, 0.16);

        this._onTrigger = this._onTrigger.bind(this);
        this._onKeydown = this._onKeydown.bind(this);

        this.$trigger.addEventListener("click", this._onTrigger);
        document.addEventListener("keydown", this._onKeydown);

        // リンククリックで閉じる
        this.$overlay.addEventListener("click", (e) => {
            const a = e.target.closest("a");
            if (a) this.close();
        });

        this.$overlay.setAttribute("aria-hidden", "true");
        this.$trigger.setAttribute("aria-expanded", "false");
    }

    open() {
        if (this.isOpen) return;
        this.isOpen = true;

        document.documentElement.classList.add(this.lockClass);
        document.body.classList.add(this.lockClass);

        this.$trigger.classList.add(this.openClass);
        this.$trigger.setAttribute("aria-expanded", "true");

        this.tl.play(0);
    }

    close() {
        if (!this.isOpen) return;
        this.isOpen = false;

        document.documentElement.classList.remove(this.lockClass);
        document.body.classList.remove(this.lockClass);

        this.$trigger.classList.remove(this.openClass);
        this.$trigger.setAttribute("aria-expanded", "false");

        this.tl.reverse();
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }

    _onTrigger() {
        this.toggle();
    }
    _onKeydown(e) {
        if (e.key === "Escape") this.close();
    }
}
